__turbopack_context__.v({
  "pager": "_2gi9TW_pager",
  "pagerInfo": "_2gi9TW_pagerInfo",
  "pagerLink": "_2gi9TW_pagerLink",
  "productsGrid": "_2gi9TW_productsGrid",
  "productsHeader": "_2gi9TW_productsHeader",
  "productsLayout": "_2gi9TW_productsLayout",
  "productsMain": "_2gi9TW_productsMain",
  "productsSidebarCol": "_2gi9TW_productsSidebarCol",
  "sortLabel": "_2gi9TW_sortLabel",
  "sortRow": "_2gi9TW_sortRow",
  "sortSelect": "_2gi9TW_sortSelect",
});
